import {UINotificationActionController} from './notifications/UINotificationActionController'
import {UIOnlineFriendController} from './ui_friends/UIOnlineFriendController'

export class UIGeneralServicesController {
    onlineFriendController: UIOnlineFriendController | undefined
    notificationActionController: UINotificationActionController | undefined
}
